import { LocalNotifications } from '@capacitor/local-notifications'

const permissionsHelper = {
    handleLocalNotification: handleLocalNotification
}

async function handleLocalNotification() {
    const granted = await LocalNotifications.checkPermissions()
    if (granted.display === 'granted') {
        return true
    } else {
        const result = await LocalNotifications.requestPermissions()
        return result.display === 'granted'
    }
}

export default permissionsHelper